import { useIntl } from "react-intl";
import TooltipTrigger from "../tooltip-trigger";

//<editor-fold desc="Props">
export interface RelativeTimeProps {
  current?: string | Date | null;
  time: string | Date;
}
//</editor-fold>

function RelativeTime(props: RelativeTimeProps) {
  //<editor-fold desc="Local variables">
  const intl = useIntl();
  let { current, time } = props;
  let timeAsNumber: number;
  let currentAsNumber: number;
  if (current) {
    currentAsNumber = 0;
  } else {
    currentAsNumber = new Date().getTime();
  }
  if (typeof time === "string") {
    time = new Date(time);
  }
  timeAsNumber = time.getTime();

  let delta = (timeAsNumber - currentAsNumber) / 1000;
  let units:
    | "seconds"
    | "minutes"
    | "hours"
    | "days"
    | "months"
    | "second"
    | "minute"
    | "hour"
    | "day"
    | "week"
    | "month"
    | "quarter"
    | "year"
    | "weeks"
    | "quarters"
    | "years"
    | undefined;
  if (delta > -3600) {
    delta = Math.round(delta / 60);
    units = "minutes";
  } else if (delta > -86400) {
    delta = Math.round(delta / 60 / 60);
    units = "hours";
  } else if (delta > -2592000) {
    delta = Math.round(delta / 60 / 60 / 24);
    units = "days";
  } else {
    delta = Math.round(delta / 60 / 60 / 24 / 30);
    units = "months";
  }
  return (
    <TooltipTrigger tipKey={"relative-time-tip"} tip={intl.formatDate(time)}>
      <span>{intl.formatRelativeTime(delta, units)}</span>
    </TooltipTrigger>
  );
}
export default RelativeTime;
